module.exports = __webpack_public_path__ + "static/media/recruitment.1286129d.svg";